<script setup lang="ts">
import Button from "@/components/Reusables/Buttons/Button.vue";
import SearchSelectLifetimeTable from "./SearchSelectLifetimeTable.vue";

const props = defineProps<{
  parents: string[];
  materialGroupings: string[];
  selectedMat: string;
  selectedStruc: string;
}>();

const emits = defineEmits(["selectMaterial", "selectStructure", "resetTable"]);

const handleSetMaterial = (material: string) => {
  emits("selectMaterial", material);
};
const handleSetStructure = (structure: string) => {
  emits("selectStructure", structure);
};
const handleEmitReset = () => {
  emits("resetTable", true);
};
</script>

<template>
  <div class="flex w-full items-end gap-4">
    <SearchSelectLifetimeTable
      :key="props.selectedStruc + props.selectedMat"
      :value="props.selectedStruc"
      placeholder="Structures"
      :options="props.parents"
      @option-selected="handleSetStructure" />
    <SearchSelectLifetimeTable
      :key="props.selectedMat + props.selectedStruc"
      :value="props.selectedMat"
      placeholder="Material"
      :options="props.materialGroupings"
      @option-selected="handleSetMaterial" />
    <Button
      class="w-1/4"
      label="Reset table"
      color="button"
      @click="handleEmitReset" />
  </div>
</template>
